import {
  LOGOUT,
  SET_IS_CONFIRM_ERROR,
  SET_IS_EMAIL_CONFIRMED,
  SET_IS_LOGIN_ERROR,
  SET_RECOVERY_TOKEN,
  SET_TOKEN
} from "./auth-types";

export const setToken = (token) => ({type: SET_TOKEN, token})
export const setIsEmailConfirmed = (isEmailConfirmed) => ({type: SET_IS_EMAIL_CONFIRMED, isEmailConfirmed})
export const setIsLoginError = (isLoginError) => ({type: SET_IS_LOGIN_ERROR, isLoginError})
export const logout = () => ({type: LOGOUT})
export const setRecoveryToken = (recoveryToken) => ({type: SET_RECOVERY_TOKEN, recoveryToken})
export const setIsConfirmError = (isConfirmError) => ({type: SET_IS_CONFIRM_ERROR, isConfirmError})
